import React from "react";
import PropTypes from "prop-types";

import { classNames } from "@/helpers/classNames";

function FooterCopyrightText({ className = "", linkClassName, copyrightText }) {
  return (
    <div className={classNames("flex justify-center", className)}>
      <span className="inline-block break-words">
        {copyrightText && `© ${new Date().getFullYear()} `}
        {copyrightText}
      </span>
    </div>
  );
}

FooterCopyrightText.propTypes = {
  className: PropTypes.string,
  copyrightText: PropTypes.object,
};

export default FooterCopyrightText;
